export function getUrlHostName(url: string): string {
    const re = new RegExp('^https?\\:\\/\\/([\\w\\.-]+)(?:\\:[0-9]{1,4})?.*$', 'i');
    const result = re.exec(url);
    return result != null && result.length > 1 ? result[1].toLowerCase() : null;
}

export default function getReferenceAttachmentDisplayUrl(
    referenceAttachmentOpenUrl: string,
    attachLongPathName: string
): string {
    const hostName = getUrlHostName(referenceAttachmentOpenUrl);
    return hostName != null ? hostName : attachLongPathName;
}
